<template>
  <div class="verification-details-pep-info">
    <h3>{{ 'verification-details-pep-info.title' | globalize }}</h3>
    <template v-if="verificationPepInfo.isNotEmptyData">
      <accordion>
        <accordion-item v-if="verificationPepInfo.isAkaNotEmpty">
          <template slot="accordion-trigger">
            <h4>{{ 'verification-details-pep-info.title-aka' | globalize }}</h4>
          </template>

          <template slot="accordion-content">
            <verification-details-pep-aka :data="verificationPepInfo.data.aka" />
          </template>
        </accordion-item>

        <accordion-item v-if="verificationPepInfo.isMediaNotEmpty">
          <template slot="accordion-trigger">
            <h4>
              {{ 'verification-details-pep-info.title-media' | globalize }}
            </h4>
          </template>

          <template slot="accordion-content">
            <verification-details-pep-media
              :media="verificationPepInfo.data.media" />
          </template>
        </accordion-item>

        <accordion-item v-if="verificationPepInfo.isAssociatesNotEmpty">
          <template slot="accordion-trigger">
            <h4>
              {{ 'verification-details-pep-info.title-associates' | globalize }}
            </h4>
          </template>

          <template slot="accordion-content">
            <verification-details-pep-associates
              :data="verificationPepInfo.data.associates" />
          </template>
        </accordion-item>

        <accordion-item
          v-if="verificationPepInfo.isSourcesNotEmpty
            && verificationPepInfo.isSourceNotesNotEmpty">
          <template slot="accordion-trigger">
            <h4>
              {{ 'verification-details-pep-info.title-sources' | globalize }}
            </h4>
          </template>

          <template slot="accordion-content">
            <verification-details-pep-sources
              :sources="verificationPepInfo.data.sources"
              :fields="verificationPepInfo.data.fields"
              :source-notes="verificationPepInfo.data.sourceNotes"
            />
          </template>
        </accordion-item>
      </accordion>
    </template>
    <template v-else>
      <a-empty :description="'verification-details-pep-info.empty-data' | globalize" />
    </template>
  </div>
</template>

<script>
import { VerificationPEPInfo } from '@/js/records/entities/verification-pep-info.record'
import VerificationDetailsPepMedia from './pep-info/Media'
import VerificationDetailsPepAka from './pep-info/Aka'
import VerificationDetailsPepAssociates from './pep-info/Associates'
import VerificationDetailsPepSources from './pep-info/Sources'
import AEmpty from 'ant-design-vue/lib/empty'
import Accordion from '../../../common/accordion/Accordion'
import AccordionItem from '../../../common/accordion/AccordionItem'

export default {
  name: 'verification-details-pep-info',
  components: {
    VerificationDetailsPepMedia,
    VerificationDetailsPepAka,
    VerificationDetailsPepAssociates,
    VerificationDetailsPepSources,
    Accordion,
    AccordionItem,
    AEmpty,
  },
  props: {
    verificationPepInfo: {
      type: VerificationPEPInfo,
      required: true,
    },
  },
}
</script>

<style lang="scss">
  @import '~ant-design-vue/lib/empty/style/index.css';

  .verification-details-pep-info {
    border-top: solid 0.1rem;
    margin-bottom: 2em;
  }

  .verification-details-pep-info h3 {
    margin-top: 4rem;
  }
</style>
